import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Form, InlineLoading, Modal } from 'carbon-components-react';

import { Delete16 } from '@carbon/icons-react';
import { parseError } from '../../../utils';
import { thunks as userThunks } from '../../../redux/actions/thunks/user';

import './index.scss';

const RegisterModal = ({
  user = [], visible, close, deleteUserProps, loadUsersHanlder
}) => {
  const [error, setError] = useState();
  const [loading, setloading] = useState(false);
  const [sucess, setSucess] = useState(false);
  const deleteUser = () => {
    setSucess(false);
    setloading(true);
    setError();
    const email = user.find(c => c.id.endsWith('email'))?.value;
    console.log(user, email);
    return deleteUserProps(email)
      .then(() => {
        setloading(false);
        setSucess(true);
        loadUsersHanlder();
      }).catch((err) => {
        setloading(false);
        setError(err);
      });
  };
  return (
    <Modal
      passiveModal
      open={!!visible}
      modalHeading={'Edit user'}
      className="cd-modal-trans"
      onRequestClose={close}
    >
      <Form noValidate>
        {
          error &&
          <div className='cd-form-error cd-mv-16'>
            {parseError(error)}
          </div>
        }
        <div className='cd-mv-16 cd-form-sucess-2'>
          {
            sucess &&
            <p>
              {'User deleted sucessfully'}
            </p>
          }
        </div>
        <div className='cd-mv-32'>
          <p>
            {'Are you sure to delete the user: '}
            <strong>{user.find(c => c.id.endsWith('email'))?.value}</strong>?
          </p>
        </div>
        <div className='cd-mt-32'>
        </div>
        <div className='cd-mt-32'>
          {
            loading ?
              <InlineLoading description="Deleting..." /> :
              <Button
                type='submit'
                kind='danger'
                onClick={() => deleteUser()}
                renderIcon={Delete16}>
                {'Yes, delete'}
              </Button>
          }
        </div>
      </Form>
    </Modal>
  );
};


const mapDispatchToProps = dispatch => bindActionCreators({
  deleteUserProps: userThunks.deleteUser
}, dispatch);

export default connect(null, mapDispatchToProps)(RegisterModal);